<template>
  <div id="app">
    <!-- <header-a @hostUrl="host"></header-a> -->
    <el-card class="teacherBasicInfo">
      <div style="font-size: 18px; font-weight: 600">基础信息</div>
      <el-divider></el-divider>
      <div class="teacherBasicInfo_content">
        <el-form label-width="100px">
          <el-form-item label="姓名:">
            <span>{{ info.name }}</span>
          </el-form-item>
          <el-form-item label="性别:">
            <span v-if="!flag">{{ info.sex ? '女' : '男' }}</span>
            <el-radio-group v-model="info.sex" v-else>
              <el-radio :label="0">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="手机号:"
            required
            :rules="[{ required: true, validator: checkphone }]"
          >
            <span v-if="!flag">{{ info.mobile }}</span>
            <el-input v-else v-model="info.mobile" placeholder="请输入手机号" />
          </el-form-item>
          <!-- <el-form-item label="生日:">
          <span>{{ info }}</span>
        </el-form-item>-->
          <el-form-item label="个人头像:">
            <el-avatar
              v-if="!flag"
              :size="120"
              shape="square"
              @error="errorHandler"
              :src="info.uploadUrl"
            >
              <img v-if="info.sex == 1" src="../../assets/img/sex0.png" />
              <img v-if="info.sex == 0" src="../../assets/img/默认头像.png" />
              <img
                v-if="info.sex == null"
                src="../../assets/img/默认头像.png"
              />
            </el-avatar>
            <el-upload
              v-else
              :action="`${urlss}/file/oss-upload`"
              :show-file-list="false"
              :headers="{ token: token }"
              accept="image/*"
              :data="datas"
              :on-success="handleAvatarSuccess"
            >
              <el-avatar
                :size="120"
                shape="square"
                @error="errorHandler"
                :src="newheadPhotoUrl"
              >
                <img v-if="info.sex == 1" src="../../assets/img/sex0.png" />
                <img v-if="info.sex == 0" src="../../assets/img/默认头像.png" />
                <img
                  v-if="info.sex == null"
                  src="../../assets/img/默认头像.png"
                />
              </el-avatar>
            </el-upload>
          </el-form-item>
          <el-form-item label="个人简介:">
            <div v-if="!flag" class="introduction">{{ info.introduction }}</div>
            <el-input
              v-else
              style="width:480px:"
              type="textarea"
              v-model="info.newintroduction"
              :rows="4"
            />
            <!-- <el-input
            v-else
            style="width:480px:"
            type="textarea"
            v-model="newintroduction"
            :rows="4"
          /> -->
          </el-form-item>
          <el-form-item>
            <el-button
              v-if="!flag"
              size="small"
              type="primary"
              @click="updateInfo"
              >修改</el-button
            >
            <el-button
              v-if="flag"
              size="small"
              type="danger"
              @click="cancelInfo"
              >取消</el-button
            >
            <el-button
              v-if="flag"
              size="small"
              type="success"
              @click="addEditor"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import headerA from '../header/header'
import { teacherData, addEditor, urls, getMyappList } from '@/api/home'
export default {
  components: {
    headerA,
  },
  data() {
    return {
      teacherId: localStorage.getItem('userId'),
      token: localStorage.getItem('token'),
      urlss: urls,
      info: {
        headPhotoUrl: '',
        createTime: '',
        id: '',
        introduction: '',
        mobile: '',
        newmobile: '',
        newintroduction: '',
        name: '',
        schoolId: '',
        sex: '',
        updateTime: '2020-01-16 10:51:57',
        serverHttp: '',
        uploadUrl: '',
      },
      newheadPhotoUrl: '',
      uploadUrl: '',
      flag: false,
      hostUrl: '',
      roleId: '',
      datas: {
        bucketId: 4,
      },
    }
  },
  created() {
    this.teacherData()
  },
  methods: {
    errorHandler() {
      return true
    },
    updateInfo() {
      this.flag = true
    },
    cancelInfo() {
      this.flag = false
    },
    host(e) {
      this.hostUrl = e
    },

    // 获取教师详情
    async teacherData() {
      const { data: res } = await teacherData(this.teacherId, {
        id: this.teacherId,
      })
      this.info = { ...res.data }
      this.info.uploadUrl = this.info.serverHttp + this.info.headPhotoUrl
      this.newheadPhotoUrl = this.info.serverHttp + this.info.headPhotoUrl
      this.info.newmobile = this.info.mobile
      this.info.newsex = this.info.sex
    },
    handleAvatarSuccess(res, file) {
      this.info.headPhotoUrl = res.data[0].fileName
      this.info.newheadPhotoUrl = res.data[0].url
      this.newheadPhotoUrl = this.info.serverHttp + res.data[0].fileName
    },
    // 保存教师
    async addEditor() {
      this.info.introduction = this.info.newintroduction
      const { data: res } = await addEditor({
        ...this.info,
      })
      this.teacherData()
      location.reload()
      this.flag = false
    },

    checkphone(rule, value, callback) {
      let reg = /^(?:(?:\+|00)86)?1\d{10}$/
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      } else if (!reg.test(value)) {
        callback(new Error('请填写正确的手机'))
      } else {
        callback()
      }
    },
    //切换身份，更新roletype
    handleRenew() {
      // this.roleType = localStorage.getItem('roleType')
      // this.showOrderOrCard = 'home'
    },
    clickRole(e) {
      this.roleId = e
      // this.getMyappList()
    },
    // 获取我的应用列表
    async getMyappList() {
      if (!this.roleId) {
        this.roleId = -1003
      }
      const { data: res } = await getMyappList({
        roleId: this.roleId,
      })
      console.log('应用列表', res.data)
      this.myappList = res.data
    },
  },
}
</script>
<style scoped>
#app {
  background-color: #ffffff;
}
.teacherBasicInfo {
  width: 1390px;
  margin: 20px auto;
  /* background-color:  #f4f4f4; */
  padding: 20px;
}
.teacherBasicInfo_content {
  margin-left: 40px;
  margin-top: 20px;
}
.introduction {
  width: 480px;
  white-space: wrap;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
}
.el-input {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/views/bench/teacherBasic.vue